import React from 'react';

const CapsuleClassName = ({ capsule }) => {
    return (
        <strong className="text-capitalize" style={{ color: capsule?.borderColor }}>{capsule?.capsuleClassName}</strong>
    );
};

export default CapsuleClassName;